import { routerStore } from '../stores/routerStore';
export function removeQueryParam(key) {
  const {
    queryString
  } = routerStore.getState();
  const params = new URLSearchParams(queryString || '');
  params.delete(key);
  return params.toString();
}
export function upsertQueryParam(key, value) {
  const {
    queryString
  } = routerStore.getState();
  const params = new URLSearchParams(queryString || '');

  // Reset the scroll to param when navigating to a new page
  params.delete('scrollTo');
  if (!value) {
    params.delete(key);
  } else {
    params.set(key, value);
  }
  return params.toString();
}
export function upsertQueryParams(...args) {
  const {
    queryString
  } = routerStore.getState();
  const params = new URLSearchParams(queryString || '');

  // Reset the scroll to param when navigating to a new page
  params.delete('scrollTo');
  for (const [key, value] of args) {
    if (!value) {
      params.delete(key);
    } else {
      params.set(key, value);
    }
  }
  return params.toString();
}
export function incrementShowInputErrors() {
  const queryString = routerStore.getState().queryString;
  if (queryString) {
    var _params$get;
    const params = new URLSearchParams(queryString);
    const inputError = (_params$get = params.get('showInputErrors')) !== null && _params$get !== void 0 ? _params$get : '0';
    return String(parseInt(inputError) + 1);
  }
  return '1';
}